import React, { useState, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useErrorHandling } from '@rd-web-markets/shared/dist/hooks/useErrorHandling';
import GroupOverviewNotesForm from './GroupOverviewNotesForm';
import GroupOverviewNotesItem from './GroupOverviewNotesItem';
import groupOverviewNotesService from '@rd-web-markets/shared/dist/services/project_report/group_overview_note.service';
const GroupOverviewNotesList = _ref => {
  let {
    elster,
    setElster
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [newNote, setNewNote] = useState({
    content: ''
  });
  const handleNoteChange = e => {
    setNewNote({
      ...newNote,
      'content': e.target.value
    });
  };
  const addNote = useErrorHandling(useCallback(async () => {
    setLoading(true);
    const createdNote = await groupOverviewNotesService.create(elster.id, newNote);
    const updatedNotes = elster.group_overview_notes;
    updatedNotes.push(createdNote);
    setNewNote({
      content: ''
    });
    setElster({
      ...elster,
      group_overview_notes: updatedNotes
    });
    setLoading(false);
  }, [newNote]));
  const removeNote = useErrorHandling(useCallback(async noteId => {
    if (window.confirm('Are you sure ?')) {
      await groupOverviewNotesService.delete(elster.id, noteId);
      let updatedNotes = elster.group_overview_notes;
      updatedNotes = updatedNotes.filter(note => note.id !== noteId);
      setElster({
        ...elster,
        group_overview_notes: updatedNotes
      });
    }
  }, [elster]));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(GroupOverviewNotesForm, {
    newNote: newNote,
    handleNoteChange: handleNoteChange,
    addNote: addNote,
    loading: loading
  }), (elster.group_overview_notes || []).map((note, index) => {
    return /*#__PURE__*/React.createElement(GroupOverviewNotesItem, {
      removeNote: removeNote,
      note: note,
      index: index
    });
  }));
};
export default GroupOverviewNotesList;